import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState, AssociateFavoriteStationAction, DissociateFavoriteStationAction, LoadStationSuccessAction, PinType, RainScale, Station, TemperatureQuality, WeathermapActions, WindType } from '@store/weathermap.store';
import { Observable } from 'rxjs';

@Injectable()
export class WeathermapFacade {
  constructor(
    private readonly store: Store<AppState>,
    private readonly actions$: Actions,
  ) {}

  private readonly selectedStation$ = this.store.select('weathermap', 'selectedStation');
  selectedStation = toSignal(this.selectedStation$);

  private readonly selectedPinType$ = this.store.select('weathermap', 'selectedPinType');
  selectedPintype = toSignal(this.selectedPinType$);

  private readonly temperatureQuality$ = this.store.select('weathermap', 'temperatureQuality');
  temperatureQuality = toSignal(this.temperatureQuality$);

  private readonly rainScale$ = this.store.select('weathermap', 'rainScale');
  rainScale = toSignal(this.rainScale$);

  private readonly windType$ = this.store.select('weathermap', 'windType');
  windType = toSignal(this.windType$);

  private readonly unitSystem$ = this.store.select('weathermap', 'unitSystem');
  unitSystem = toSignal(this.unitSystem$);

  private readonly windUnit$ = this.store.select('weathermap', 'windUnit');
  windUnit = toSignal(this.windUnit$);

  private readonly pressureUnit$ = this.store.select('weathermap', 'pressureUnit');
  pressureUnit = toSignal(this.pressureUnit$);

  selectStation(station: Station): void {
    this.store.dispatch(WeathermapActions.selectStation({ station }));
  }

  selectPinType(pinType: PinType): void {
    this.store.dispatch(WeathermapActions.selectPinType({ pinType }));
  }

  selectTemperatureQuality(temperatureQuality: TemperatureQuality): void {
    this.store.dispatch(WeathermapActions.selectTemperatureQuality({ temperatureQuality }));
  }

  selectRainScale(rainScale: RainScale): void {
    this.store.dispatch(WeathermapActions.selectRainScale({ rainScale }));
  }

  selectWindType(windType: WindType): void {
    this.store.dispatch(WeathermapActions.selectWindType({ windType }));
  }

  selectUnitSystem(unitSystem: number): void {
    this.store.dispatch(WeathermapActions.selectUnitSystem({ unitSystem }));
  }

  selectUnitWind(windUnit: number): void {
    this.store.dispatch(WeathermapActions.selectUnitWind({ windUnit }));
  }

  selectUnitPressure(pressureUnit: number): void {
    this.store.dispatch(WeathermapActions.selectUnitPressure({ pressureUnit }));
  }

  loadStation(stationId: string): Observable<LoadStationSuccessAction> {
    this.store.dispatch(WeathermapActions.loadStation({ stationId }));
    return this.actions$.pipe(
      ofType(WeathermapActions.loadStationSuccess),
    );
  }

  associateFavoriteStation(station: Station): Observable<AssociateFavoriteStationAction> {
    this.store.dispatch(WeathermapActions.associateFavoriteStation({ stationId: station.id, name: station.city }));
    return this.actions$.pipe(
      ofType(WeathermapActions.associateFavoriteStationSuccess),
    );
  }

  dissociateFavoriteStation(station: Station): Observable<DissociateFavoriteStationAction> {
    this.store.dispatch(WeathermapActions.dissociateFavoriteStation({ stationId: station.id }));
    return this.actions$.pipe(
      ofType(WeathermapActions.dissociateFavoriteStationSuccess),
    );
  }
}
